import React from "react";
import { TourProvider, ProviderProps, useTour } from "@reactour/tour";
import { useChatTourStore } from "../../ChatTourStore";

export function ChatTourProvider({
  chatEnabled,
  children,
}: React.PropsWithChildren<{ chatEnabled: boolean }>) {
  const tourProps = React.useMemo<Omit<ProviderProps, "children">>(
    () => ({
      showNavigation: false,
      steps: [
        {
          selector: "#chat-button",
          content: "Try Agent - your AI assistant for data insights!",
        },
      ],
    }),
    [],
  );

  return (
    <TourProvider disableDotsNavigation showBadge={false} {...tourProps}>
      <ChatTourControl chatEnabled={chatEnabled}>{children}</ChatTourControl>
    </TourProvider>
  );
}

function ChatTourControl({
  children,
  chatEnabled,
}: React.PropsWithChildren<{ chatEnabled: boolean }>) {
  const { setIsOpen: setIsTourOpen, isOpen: tourIsOpen } = useTour();
  const { hasSeentour, tourWasSeen } = useChatTourStore();
  const showTour = chatEnabled && !hasSeentour;
  const tourStarted = React.useRef(false);

  React.useEffect(() => {
    if (!showTour) {
      return;
    }
    if (!tourStarted.current) {
      setIsTourOpen(true);
      tourStarted.current = true;
    } else if (!tourIsOpen) {
      setIsTourOpen(false);
      tourWasSeen();
    }
  }, [showTour, setIsTourOpen, tourIsOpen, tourWasSeen]);

  return <>{children}</>;
}
